import styled from '@nykaa/ui-components/styles/styled';
import ImageV2 from 'shared/components/ImageV2/Image';
import BaseButton from 'shared/components/Button';
import BaseOverlaySheet from 'shared/components/OverlaySheet';
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.spacing80};
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 0 0 ${({ theme }) => theme.borders.radius40} ${({ theme }) => theme.borders.radius40};
`;

export const Title = styled.span`
  ${({ theme }) => theme.typography.subTitleMedium};
  color: ${({ theme }) => theme.colors.textSecondary};
  width: 100%;
`;


export const OverlaySheetWrapper = styled.div`
  transition: all 0.2s ease;
  ${({ theme }) => `
    background-color: transparent;
    border-radius: ${theme.borders.radius40} ${theme.borders.radius40} 0 0;
    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      box-shadow: 0 ${theme.spacing.spacing80} 20px 0 rgba(0, 0, 0, 0.14);
      border-radius: ${theme.borders.radius40};
    }
  `};
`;

export const OverlaySheet = styled(BaseOverlaySheet)`
  width: 100%;
  min-height: 40%;
  transition: height 0.3s ease-in-out;
  top: initial;
  animation-duration: 0.3s;
  touch-action: none;
  ${({ theme }) => `
    background-color: transparent;
    border-radius: ${theme.borders.radius40};
    padding: ${theme.spacing.spacing40};
  `};
`;

export const OverlaySheetDesktop = styled(BaseOverlaySheet)`
  width: 344px;
  position: fixed;
  transition: height 0.3s ease-in-out;
  top: 107px;
  left: auto;
  animation-duration: 0.3s;
  touch-action: none;
  bottom: initial;
  ${({ theme }) => `
    background-color: transparent;
    border-radius: ${theme.borders.radius40};
    right: ${theme.spacing.spacing80};
    border: 1px solid ${theme.colors.surface30};
  `};
`;

export const ProductRow = styled.div<{ moreProduct: boolean; }>`
  display: flex;
  align-items: flex-start;
  width: 100%;
  ${({ theme, moreProduct }) => `
    margin: ${theme.spacing.spacing80} ${theme.spacing.spacing80} ${moreProduct ? theme.spacing.spacing120 : theme.spacing.spacing80} ${theme.spacing.spacing80} ;
  `};
`;

export const ProductImage = styled(ImageV2)`
  width: 76px;
  border-radius: ${({ theme }) => theme.spacing.spacing40};
  object-fit: cover;
  margin-right: ${({ theme }) => theme.spacing.spacing80};
`;

export const ProductDetails = styled.div`
  flex: 1;
  overflow-x: auto;
  ${({ theme }) => `
    margin: ${theme.spacing.spacing20} 0;
  `};
`;

export const ProductName = styled.div`
  ${({ theme }) => theme.typography.subTitleSmall};
  color: ${({ theme }) => theme.colors.primary};
  
`;

export const ProductDesc = styled.div`
${({ theme }) => theme.typography.bodySmall};
${({ theme }) => `
    margin-top: ${theme.spacing.spacing20};
    color: ${theme.colors.textSecondary};
  `};
text-overflow: ellipsis;
white-space: nowrap;
overflow: hidden;
width: 100%;
`;

export const ProductMeta = styled.div`
${({ theme }) => `
    margin-top: ${theme.spacing.spacing20};
    color: ${theme.colors.primary};
  `};
  ${({ theme }) => theme.typography.bodySmall};

`;

export const ProductPriceRow = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => `
    margin-top: ${theme.spacing.spacing40};
  
    & span {
      font-size: ${theme.spacing.spacing60} !important;
    }
  `};
  
`;

export const BagInfo = styled.div`
  ${({ theme }) => theme.typography.subTitleSmall};
  ${({ theme }) => `
    margin-bottom: ${theme.spacing.spacing60};
    color: ${theme.colors.textSecondary};
  `};
  width: 100%;
`;

export const BagItemsRow = styled.div`
  display: flex;
  ${({ theme }) => `
    gap: ${theme.spacing.spacing20};
    margin-bottom: ${theme.spacing.spacing80};
  `};
  width: 100%;
  overflow-x: scroll;
`;

export const BagItemImage = styled(ImageV2)`
  width: 42px;
  height: 56px;
  border-radius: ${({ theme }) => theme.borders.radius20};
  object-fit: cover;
`;

export const BagItemPlaceholder = styled.div`
  width: 42px;
  height: 56px;
  border-radius: ${({ theme }) => theme.borders.radius20};
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.typography.subTitleSmall};
  ${({ theme }) => `
    background: ${theme.colors.surface10};
    border: 0.438px solid ${theme.colors.textDecorative};
    color: ${theme.colors.textSecondary};
  `};
`;

export const ActionButtonRow = styled.div`
  display: flex;
  width: 100%;
  ${({ theme }) => `
    margin-top: ${theme.spacing.spacing20};
    gap: ${theme.spacing.spacing40};
  `};
`;

export const ActionButton = styled(BaseButton)`
  ${({ theme }) => theme.typography.buttonLarge};
  flex: 1;
  ${({ theme }) => `
    color: ${theme.colors.textInversePrimary};
    height: ${theme.spacing.spacing240};
    border-radius: ${theme.borders.buttonBorderRadius};
    background: ${theme.colors.primary};
    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      border-radius: ${theme.borders.mwebButtonBorderRadius};
    }
  `};
`;

export const SecondaryButton = styled(BaseButton)`
  ${({ theme }) => theme.typography.buttonLarge};
  flex: 1;
  ${({ theme }) => `
    color: ${theme.colors.primary};
    height: ${theme.spacing.spacing240};
    border-radius: ${theme.borders.buttonBorderRadius};
    background: transparent;
    border: 1px solid ${theme.colors.primary};
    &:not([disabled]):hover {
      background: ${theme.colors.surface10};
    }
    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      border-radius: ${theme.borders.mwebButtonBorderRadius};
    }
  `};
`;
